export default {
  siteId: 'www.singtel.com_1',
  showErrors: process.env.NODE_ENV === 'development',
  layout: {
    navigation: {
      position: 'top'
    }
  },
  suggestions: {
    highlight: false
  },
  style: {
    themeColor: '#000000',
    suggestions: {
      text: {
        color: '#000000'
      },
      background: {
        color: '#ffffff'
      },
      padding: '10px',
      distanceFromTop: '7px',
      border: {
        color: '#dddddd',
        radius: '7px'
      }
    },
    searchBox: {
      text: {
        color: '#000000',
        size: '1rem'
      },
      background: {
        color: '#ffffff'
      },
      padding: '10px',
      border: {
        color: '#3D393A',
        radius: '7px'
      }
    }
  },
  searchBox: {
    placeholder: 'Search',
    selector: '.ss360SearchBox'
  },
  results: {
    embedConfig: {
      contentBlock: '#searchResults',
      url: 'https://cdn.aws.singtel.com/search/search.html'
    },
    caption: "We found #COUNT# results for your query '#QUERY#'",
    num: 200,
    searchQueryParamName: 'rinput',
    moreResultsPagingSize: 50
  },
  contentGroups: {
    otherName: 'Other'
  },
  specialMobileSuggest: {
    enabled: false
  }
};
